var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"pager--start"},[_vm._v(_vm._s(_vm.start))]),_c('div',{staticClass:"subscriptpager"},[_c('span',{staticClass:"pager--stripe"},[_vm._v("/")]),_c('span',{staticClass:"pager--end"},[_vm._v(_vm._s(_vm.end))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }